export default function (code,vueInstance) {
  switch (code) {
    case 'KYC500': return "Verificação de conta ainda está pendente! Se você já realizou o envio para criar sua conta, por favor aguarde para enviar os documentos."
    case 'KYC501': return "Você atingiu o limite máximo de envios para CNH, por favor entre em contato com suporte."
    default: return `Ocorreu um erro durante atualizações dos dados. - Código: ${code}`
  }
}
